import Box from "@/ui/atoms/Box";
import type {
    ExtractionInfo,
    FileInfoWithParent,
    FileExtractionInfo,
} from "../dealTypes";
import { isExtractionInfoWithParentTypeGuard } from "../DealOverview/DealProcessedFiles";
import { isFileInfoWithParentTypeGuard } from "../DealOverview/DealProcessedFiles";
import { Checkbox } from "@proda-ai/ui-kit";

type CheckboxRendererProps = {
    node: { data: FileExtractionInfo };
    getSelectedStatus: (
        fei: FileExtractionInfo,
    ) => "selected" | "intermediate" | "unselected";
    toggleExtraction: (extraction: ExtractionInfo) => void;
    setEntireFiles: (
        files: FileInfoWithParent[],
        setTo: boolean,
        exclusive: boolean,
    ) => void;
    header: boolean;
};

export const CheckboxRenderer: React.FC<CheckboxRendererProps> = ({
    node,
    getSelectedStatus,
    toggleExtraction,
    setEntireFiles,
}) => {
    if (
        !isFileInfoWithParentTypeGuard(node.data) &&
        !isExtractionInfoWithParentTypeGuard(node.data)
    ) {
        return null;
    }
    const checkedState = getSelectedStatus(node.data);
    return (
        <Box
            sx={{
                width: "25px",
                display: "flex",
                alignItems: "center",
                height: "100%",
            }}
        >
            <Checkbox
                label=""
                value={node.data.fileId.toString()}
                checked={
                    checkedState === "selected" ||
                    checkedState === "intermediate"
                }
                indeterminate={checkedState === "intermediate"}
                onChange={() => {
                    if (isFileInfoWithParentTypeGuard(node.data)) {
                        setEntireFiles(
                            [node.data],
                            checkedState !== "selected",
                            false,
                        );
                    } else if (isExtractionInfoWithParentTypeGuard(node.data)) {
                        toggleExtraction(node.data);
                    }
                }}
            />
        </Box>
    );
};
